<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<h2>{{'auth.users' | translate}}</h2>

<div class="card">
    <p-table [value]="users"
             [lazy]="true"
             [rows]="10" [paginator]="true"
             [totalRecords]="totalRecords"
             (onLazyLoad)="loadUsersLazy($event)"
             [pageLinks]="9"
             [responsive]="true"
             sortField="name"
             [rowsPerPageOptions]="[10,20,30]"
             #usersTable data-testid="table">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name" width="60%">
                    {{'auth.username' | translate}}
                    <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th width="30%">{{'auth.activeTo' | translate}}</th>
                <th width="10%"></th>
            </tr>
            <tr>
                <th>
                    <input pInputText type="text" [ngStyle]="{'width':'100%'}"
                           placeholder="{{'auth.search' | translate}}"
                           (input)="usersTable.filter($event.target['value'], 'name', 'contains')" data-testid="input">
                </th>
                <th>
                    <p-select [options]="activeOpt"
                                [(ngModel)]="filterActive"
                                (onChange)="usersTable.filter($event.value, 'active', 'equals')"
                     data-testid="filter-active-select"></p-select>
                    <!--[name]="parameter.name"-->
                    <!--[autoDisplayFirst]="false"-->
                    <!--[filter]="true"-->
                    <!---->

                    <!--required-->

                    <!--<p-multiselect [options]="activeOpt"
                                   [defaultLabel]="allRecordsTranslation"
                                   [(ngModel)]="selectedActiveOpts"
                                   selectedItemsLabel = "{{'auth.itemsSelected' | translate}}"
                                   (onChange)="usersTable.filter($event.value,'active','in')" data-testid="selected-active-opts-multiselect">
                    </p-multiselect>-->
                </th>
                <th align="right">
                    <button type="button" pButton
                            (click)="newUser()"
                            icon="ui-icon-add"
                            pTooltip="{{'auth.add' | translate}}" data-testid="new-user-btn"></button>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr>
                <td align="center">{{user.name}}</td>
                <td>{{user.activeTo ? (user.activeTo | date: 'dd.MM.yyyy') : ('auth.indefinitely' | translate)}}</td>
                <td align="right">
                    <button type="button" pButton
                            (click)="edit(user)"
                            icon="ui-icon-edit"
                            pTooltip="{{'auth.edit' | translate}}" data-testid="edit-btn"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

